<!--
 * @Author: wsx
 * @Date: 2022-01-05 18:45:47
 * @LastEditTime: 2022-01-12 18:03:34
 * @LastEditors: your name
 * @Description:弹框播放视频
-->
<template>
  <h-dialog
    :title="title"
    v-model="dialogVisble"
    :height="title != '相机信息' ? '60vh' : '50vh'"
    :width="title != '相机信息' ? '50vw' : '30vw'"
    :zIndex="zIndex"
    @close="closeDialog"
  >
    <div class="video-card" v-if="title != '相机信息'">
      <!-- <span >下载视频控件</span> -->
      <h-video
        ref="cameraRef"
        layout="1"
        v-model:videoConnected="videoConnected"
      ></h-video>
    </div>

    <div v-else class="content">
      <el-row>
        <el-col :span="6">摄像机名称</el-col>
        <el-col :span="16">{{ addressInfo.cameraName }}</el-col>
        <el-divider></el-divider>
      </el-row>

      <el-row>
        <el-col :span="6">设备状态</el-col>
        <el-col :span="16">{{
          addressInfo.deviceLineStatus == "0"
            ? "正常"
            : addressInfo.deviceLineStatus == "1"
            ? "离线"
            : addressInfo.deviceLineStatus == "2"
            ? "故障"
            : ""
        }}</el-col>
        <el-divider></el-divider>
      </el-row>
      <el-row>
        <el-col :span="6">IP地址</el-col>
        <el-col :span="16">{{ addressInfo.cameraIpAddrs }}</el-col>
        <el-divider></el-divider>
      </el-row>
      <el-row>
        <el-col :span="6">经度</el-col>
        <el-col :span="16">{{ addressInfo.latitude }}</el-col>
        <el-divider></el-divider>
      </el-row>

      <el-row>
        <el-col :span="6">纬度</el-col>
        <el-col :span="16">{{ addressInfo.longitude }}</el-col>
        <el-divider></el-divider>
      </el-row>

      <el-row>
        <el-col :span="6">厂商ID</el-col>
        <el-col :span="16">{{ addressInfo.otherId }}</el-col>
        <el-divider></el-divider>
      </el-row>
    </div>
    <div class="timeRange" v-if="title == '视频回放'">
      <el-row>
        <el-col :span="24" class="playbackInput">
          <el-date-picker
            style="width: 100%"
            v-model="tableParams.startTime"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            :disabled-date="startDisabledDate"
            size="mini"
            placeholder="开始时间"
            @change="getTime"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="24" class="playbackInput">
          <el-date-picker
            style="width: 100%"
            v-model="tableParams.endTime"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            :disabled-date="endDisabledDate"
            size="mini"
            placeholder="结束时间"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="24">
          <h-button
            type="primary"
            size="small"
            @click="playBackCamera(true)"
            style="width: 100%"
            >回放</h-button
          >
        </el-col>
      </el-row>
    </div>

    <!-- itemData.repositoryName ? itemData.repositoryName : "--" -->
  </h-dialog>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs,
  useSlots,
  watchEffect,
  ref,
  watch,
} from "vue";
import HVideo from "@/components/HVideo";
import client from "@/plugins/videoClient/videoClient.js";
import { playVideo, playVideoByDeviceId } from "@/api/videoControl/videoApi.js";
import moment from "moment";
export default defineComponent({
  name: "HVideoDialog",
  components: { HVideo },
  props: {
    title: {
      type: Boolean,
      default: "实时视频",
    },
    visible: {
      type: String,
      default: false,
    },
    videoData: {
      type: Object,
      default: () => {},
    },
    zIndex: {
      type: Number,
      default: 10,
    },
  },
  setup(props, { emit }) {
    const data = reactive({
      dialogVisble: false,
      addressInfo: {}, //位置信息
      time: null,
      videoConnected: false,
      tableParams: {
        endTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        startTime: moment(new Date().getTime() - 3600 * 1000 * 24).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        //,
      },
    });
    watchEffect(() => {
      data.dialogVisble = props.visible;
    });
    watchEffect(() => {
      if (data.videoConnected) {
        clearInterval(data.time);
        if (props.title == "实时视频") {
          playCamera();
        } else if (props.title == "视频回放") {
          playBackCamera();
          console.log(props.videoData.passTime);
          if (props.videoData.passTime) {
            data.tableParams.startTime = moment(
              parseInt(props.videoData.passTime) - 60 * 1000
            ).format("YYYY-MM-DD HH:mm:ss");
            data.tableParams.endTime = moment(
              parseInt(props.videoData.passTime) + 60 * 1000
            ).format("YYYY-MM-DD HH:mm:ss");
          }
        } else {
          showAddress();
        }
      }
    });
    data.time = setInterval(() => {
      data.videoConnected =
        window.localStorage.getItem("videoConnected") === "true" ? true : false;
    }, 1000);
    const refData = toRefs(data);
    const cameraRef = ref(null);
    if (props.title != "相机信息" && !data.videoConnected)
      client.connect("ws://127.0.0.1:4502");
    //播放视频
    const playCamera = async () => {
      console.log(props.videoData);
      const params = {
        cameraId:
          props.videoData.cameraId || props.videoData[0].values_.item.cameraId,
      };
      const playCameraData = await playVideo(params);
      // const camera = {
      //   cameraId: "321321",
      //   cameraName: "测试线路",
      //   cameraBrand: "6002",
      //   mode: "2",
      //   index: "0",
      //   platform: null,
      //   dvr: {
      //     channel: "50015400051191002461",
      //     brand: "6002",
      //     ip: "50.136.71.45",
      //     port: "11125",
      //     userName: "user123",
      //     password: "123456",
      //   },
      //   stream: null,
      // };
      // cameraRef.value.play(camera);
      cameraRef.value.play(playCameraData.result);
    };
    //播放回放
    const playBackCamera = async (btn) => {
      let playCameraData;
      let passTime = props.videoData.passTime;
      if (props.videoData.deviceId) {
        const params = {
          otherId: props.videoData.deviceId,
        };
        playCameraData = await playVideoByDeviceId(params);
      } else {
        const params = {
          cameraId: props.videoData[0].values_.item.cameraId,
        };
        playCameraData = await playVideo(params);
      }
      if (btn) passTime = ""; //按钮点击播放就不需要passTime

      playCameraData.result.index = 0;
      playCameraData.result.endTime = passTime
        ? moment(parseInt(props.videoData.passTime) + 60 * 1000).format(
            "YYYY-MM-DD HH:mm:ss"
          )
        : data.tableParams.endTime;
      playCameraData.result.startTime = passTime
        ? moment(parseInt(props.videoData.passTime) - 60 * 1000).format(
            "YYYY-MM-DD HH:mm:ss"
          )
        : data.tableParams.startTime;
      cameraRef.value.playback([playCameraData.result]);
    };
    //定位
    const showAddress = async () => {
      const params = {
        cameraId: props.videoData[0].values_.item.cameraId,
      };
      const playCameraData = await playVideo(params);
      data.addressInfo = {
        ...props.videoData[0].values_.item,
        ...playCameraData.result,
      };
    };
    // 关闭菜单
    const closeDialog = () => {
      data.videoConnected = false;
      emit("update:visible", false);
    };
    watch(
      [() => data.tableParams.startTime, () => data.tableParams.endTime],
      (val, prev) => {
        const [start, end] = val;
        if (moment(start).format("x") > moment(end).format("x")) {
          data.tableParams.startTime = prev[0];
          data.tableParams.endTime = prev[1];
          ElMessage.error("开始时间不能小于结束时间");
        }
      }
    );
    const startDisabledDate = (time) => {
      const endDate = moment(data.tableParams.endTime).format("x");
      return time.getTime() > endDate;
    };
    const endDisabledDate = (time) => {
      const startDate = `${moment(data.tableParams.startTime).format(
        "YYYY-MM-DD"
      )} 00:00:00`;
      const startTime = moment(startDate).format("x");
      return time.getTime() > Date.now() || time.getTime() < startTime;
    };
    return {
      ...refData,
      cameraRef,
      closeDialog,
      startDisabledDate,
      endDisabledDate,
      playBackCamera,
    };
  },
});
</script>
<style  lang='scss' scoped >
$space: 6px;
.video-card {
  flex: 1;
  margin-left: 10px;
  // width: 800px;
  height: 100%;
  // background-color: #333;
  // @include flex-col-c-c;
  #videoId {
    // flex: 1;
    height: 100%;
    width: 100%;
  }
}
.content {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-around;
  padding: 20px;
  .el-divider {
    margin: 12px 0;
  }
}
.timeRange {
  position: absolute;
  width: 230px;
  height: 140px;
  top: 0;
  right: -280px;
  padding: 15px;
  background: rgba(3, 23, 68, 0.8);
  .playbackInput {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>